<template>
  <div class=" middle">
    <b-row class="TitleArea">
      <b-col sm="12" lg="6">
          <h1 class="heading">Clutch Tour Latest Youtube Videos</h1>
      </b-col>
      <b-col sm="12" lg="6" class="above769">
        <b-link href="https://www.youtube.com/channel/UCS34dfBB8jyD98wSFgrwBoA" class="allNewsLink" target="_blank">
          <button class="Allbuttons" :style="colourTour" :class="{colorBtn : $route.name == 'schedule'}">
            See All Videos
          </button>
        </b-link>
      </b-col>
    </b-row>
    <div v-if="loading == true">
      <div class="loader"></div>
      <h2 class="loading">Loading...</h2>
    </div>
    <b-row >
      <b-col
        class="col-md-6 col-sm-12 col-lg-4 mobileCol"
        v-for="(gallery, index) in videos.items.slice(0,6)"
        :key="'twentythreedex' + index"
      >
        <b-embed
          type="iframe"
          aspect="16by9"
          :src="
            'https://www.youtube.com/embed/' +
              gallery.contentDetails.videoId
          "
          allowfullscreen
        ></b-embed>
        <iframe width="100%" height="300px" aspect="16by9" :src="'https://www.youtube.com/embed/' + gallery.contentDetails.videoId" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <!-- <h4 class="videoText">Video</h4> -->
        <p class="galleryTitle">
          {{ gallery.snippet.title }}
        </p>
      </b-col>
    </b-row>
    <b-row class="below769">
      <b-col sm="12" lg="6">
        <b-link href="https://www.youtube.com/channel/UCS34dfBB8jyD98wSFgrwBoA" class="allNewsLink" target="_blank">
          <button class="Allbuttons" :style="colourTour" :class="{colorBtn : $route.name == 'schedule'}">
            See All Videos
          </button>
        </b-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import apiCall from "@/services/api.js";
import axios from 'axios';
export default {
  name: "youTube",
  data() {
    return {
      videos: [],
      youtubeChannel: '',
      youtubeAPI: '',
      loading: true
    };
  },
  props: [
    'config'
  ],
  methods: {
    getYoutube: function() {
      axios
        .get(
            "https://api.euro.ocs-software.com/cpt/cache/cpt/tmticx?randomadYou=" +
              new Date().getTime()
        )
        .then((response) => {
          // this.feature = response.data;
            console.log('FirstCall')
            this.youtubeAPI = response.data.tm_params.youtube_keys.youtube_key.youtube_api;
            this.youtubeChannel = response.data.tm_params.youtube_keys.youtube_key.youtube_channel;
            // this.youtubeChannel = 'UC88jp_VEEHXDJzDjAA2lqwg';
            this.loading = false;
            return axios.get(
            'https://api.euro.ocs-software.com/youtube/videos?playlistId=' + this.youtubeChannel + '&key=' + this.youtubeAPI + '&maxResults=10&type=video&order=date&part=snippet,contentDetails&'
            ) .then((response) => {
              this.videos = response.data;
              console.log('SecondCall')
              this.loading = false;
            });
        });
    }
  },
  mounted() {
    this.getYoutube();
  },
};
</script>

<style scoped>
@media only screen and (min-width: 770px) {
  .below769 {
    display: none;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
}
.Allbuttons {
  float: right;
  width: 272px;
  height: 52px;
  background: #081C3F;
  /* color: #081C3F; */
  color: #fff;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 0px;
  border: 0px solid #081C3F;
  font-size: 18px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
.Allbuttons:hover {
  float: right;
  width: 272px;
  height: 52px;
  background-color: #081C3F!important;
  background: #081C3F!important;
  color: #fff!important;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 0px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  border-radius: 26px;
}
h2.loading {
  padding-top: 20px;
  font-weight: 600;
  font-size: 24px;
  color: #081C3F;
  text-align: center;
  /* padding-bottom: 90px; */
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #081C3F; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
  display: block;
}
.loaderSection {
  padding-top: 30px;
  padding-bottom: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  padding-bottom: 10px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.middle {
  margin: auto;
}
.row {
  padding-bottom: 20px;
}
.col {
  padding-bottom: 20px;
}
h4.videoText {
  font-size: 20pt;
  margin-top: 30px;
}
p.galleryTitle {
  color: #081C3F;
  font-size: 18px;
  /* font-weight: bold; */
  margin-top: 20px;
  /* font-weight: 600; */
}
@media only screen and (max-width: 990px) {
  .heading{
    /* font-weight: 600; */
    font-size: 26px;
    color: #081C3F;
    padding-bottom: 0px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  .Allbuttons {
    float: none;
    width: 100%;
    height: 52px;
    background: #081C3F;
    /* color: #081C3F; */
    color: #fff;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 0px;
    border: 0px solid #081C3F;
    font-size: 18px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    margin-top: 25px;
    margin-bottom: 5px;
    border-radius: 26px;
  }
  .Allbuttons:hover {
    float: none;
    width: 100%;
    height: 52px;
    background-color: #081C3F!important;
    background: #081C3F!important;
    color: #fff!important;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 0px;
    border: 1px solid #E8E8E8;
    transform: translateY(-10px);
    margin-top: 25px;
    margin-bottom: 5px;
    border-radius: 26px;
  }
}
@media only screen and (max-width: 550px) {
  ::v-deep .col-md-6.col-sm-12.col-lg-4.mobileCol.col {
    flex: 0 0 100%!important;
    max-width: 100%!important;
  }
}
@media only screen and (max-width: 480px) {
  .mobHide {
    display: none;
  }
}
</style>
